'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.default = menuRootSage;

var _effects = require('redux-saga/effects');

var _index = require('../index.js');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(onBiEvent),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(menuRootSage);

function onBiEvent(sagaParams, action) {
    var _sagaParams$bi, bi, event;

    return _regenerator2.default.wrap(function onBiEvent$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _sagaParams$bi = sagaParams.bi, bi = _sagaParams$bi === undefined ? _index.BI : _sagaParams$bi;
                    event = _lodash2.default.find(bi.EVENTS, function (event, key) {
                        return 'WIXREST_BI_' + key === action.type;
                    });

                    // Currently don't send event 238 on food.co.il restaurants - please delete this after January 2018 if you see this

                    if (!(action.type === 'WIXREST_BI_MOBILE_ONLINE_ORDERING_FLOW' && typeof window !== 'undefined' && window.WixInstance && window.WixInstance.getSiteOwnerId() === '0fe75971-3520-4488-97fc-fc8a47e71b28')) {
                        _context.next = 4;
                        break;
                    }

                    return _context.abrupt('return');

                case 4:

                    bi.event(event, action.payload);

                case 5:
                case 'end':
                    return _context.stop();
            }
        }
    }, _marked, this);
}

var waitForBiEvents = /*#__PURE__*/_regenerator2.default.mark(function waitForBiEvents(sagaParams) {
    return _regenerator2.default.wrap(function waitForBiEvents$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return (0, _effects.takeEvery)(function (action) {
                        return _lodash2.default.startsWith(action.type, 'WIXREST_BI_');
                    }, onBiEvent.bind(null, sagaParams));

                case 2:
                case 'end':
                    return _context2.stop();
            }
        }
    }, waitForBiEvents, this);
});

function menuRootSage(sagaParams) {
    return _regenerator2.default.wrap(function menuRootSage$(_context3) {
        while (1) {
            switch (_context3.prev = _context3.next) {
                case 0:
                    _context3.next = 2;
                    return [(0, _effects.fork)(waitForBiEvents.bind(null, sagaParams))];

                case 2:
                case 'end':
                    return _context3.stop();
            }
        }
    }, _marked2, this);
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-bi/dist/redux/Saga.js
// module id = 885
// module chunks = 0